import { actions } from './actions'

const initialState = {
  provincias: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function provinciaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.PROVINCIAS_LOAD_REQUESTED:
      return { ...state, provincias: { ...state.provincias, loading: true } }
    case actions.PROVINCIAS_LOAD_SUCCEEDED:
      return { ...state, provincias: { ...state.provincias, data: action.payload, loading: false } }
    case actions.PROVINCIAS_LOAD_FILED:
      return { ...state, provincias: { ...state.provincias, loading: false, error: action.error } }
    case actions.PROVINCIA_UPDATE_REQUESTED:
      return {
        ...state,
        provincias: { ...state.provincias, loading: true, error: '' },
      }
    case actions.PROVINCIA_UPDATE_SUCCEEDED:
      return {
        ...state,
        provincias: {
          ...state.provincias,
          data: state.provincias.data.map(prov =>
            prov.id === action.payload.id ? action.payload : prov,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.PROVINCIA_UPDATE_FILED:
      return {
        ...state,
        provincias: { ...state.provincias, loading: false, error: action.error },
      }
    default:
      return state
  }
}
